var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"relative",attrs:{"cols":"4"}},[_c('canvas',{ref:"doughnutChart"}),(_vm.data && _vm.data.score)?_c('span',{staticClass:"absolute text-h4",attrs:{"id":"score"}},[_vm._v(_vm._s(_vm.data.score))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }